import { getImgOptions, useDeleteImgDesc, useDeleteMedia, useUpdatePerson, useImgDescs, usePeople} from "../hooks/hooks_index";
import { useAuthUser, ImgZoom, Loading } from "../components/components_index";
import { Link } from "react-router-dom";
import { useState, useEffect } from "react";
import { useQueryClient } from "@tanstack/react-query";
import '../styles/UploadedPhotos.css'

export default function UploadedPhotos() {
  const { loginID } = useAuthUser();
  const queryClient = useQueryClient();
  const [images, setImages] = useState(); 
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState();
  const [isEditing, setIsEditing] = useState(false);
  const [selectedImgs, setSelectedImgs] = useState([]);
  const [isDeleting, setIsDeleting] = useState(false);
  const deleteImgDesc = useDeleteImgDesc();
  const deleteMedia = useDeleteMedia();
  const updatePerson = useUpdatePerson();
  const {data: imgDescs} = useImgDescs();
  const {data: peopleData} = usePeople();

  const monthNames = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
  ];

  function editImgMode() {
    if (isEditing) setSelectedImgs([]);
    setIsEditing(!isEditing);
  }

  function toggleSelected(photoID) {
    if (selectedImgs.includes(photoID)) {
      setSelectedImgs(selectedImgs.filter(imgID => imgID !== photoID));
    } else {
      setSelectedImgs(selectedImgs => [...selectedImgs, photoID]);
    }
  }
  
  async function deleteImgs() {
    setIsDeleting(true);
    const deletedImgs = [...selectedImgs];

    try {
      for (const imgID of deletedImgs) {
        const imgDesc = imgDescs[imgID]

        if (imgDesc?.profilePic) {
          const picPerson = imgDesc.profilePic.split('_')[0]
          const personData = peopleData[picPerson];
          if (personData?.profile_pic) {
            const {profile_pic, ...other} = personData
            await updatePerson.mutateAsync({
              id: picPerson,
              data: other
            });
          }
        }

        await deleteMedia.mutateAsync(imgID);
        await deleteImgDesc.mutateAsync(imgID);

        queryClient.invalidateQueries(['people', loginID])
      }

      setImages(prev =>
        prev.filter(img => !deletedImgs.includes(img.media_id))
      );

      setSelectedImgs([]);
      setIsEditing(false);

    } catch (err) {
      console.error("Delete failed:", err);
    }

    setIsDeleting(false);
  }

  useEffect(() => {
    setIsLoading(true)
      getImgOptions({
        uploaded_by: loginID,
        sortByDate: ["saved_date", "desc"]
      })
        .then(data => {
          setImages(data);
          setIsLoading(false);
        })
        .catch(err => {
          setError(err.message)
          setIsLoading(false)
        });
    }, [loginID]);

  if (error) return <div>Error: {error}</div>

  return (
    <div className="uploaded-photos-page">
      {isLoading && <Loading/>}
      {!images && !isLoading &&
        <div className="no-uploaded">You haven't uploaded any images</div>
      }
      {images &&
        <div>
          <div className={`uploaded-photos-title${isEditing?" editing-photos":""}`}>{isEditing?"Select Photos to Delete":`Photos You've Uploaded (${images.length} total)`}</div>
          <div className="photos-layout">
            {!isDeleting &&
              <div className="photos-container">
                {images.map(img => (
                  <div className={`uploaded-photos-image-object${isEditing?" editing-photo":""}${selectedImgs.includes(img.media_id)?" photo-selected":""}`} key={img.media_id} onClick={(e) => {
                    e.stopPropagation();
                    if (isEditing) toggleSelected(img.media_id);
                  }}>
                    <ImgZoom src={img.media_id} alt={img.subtext || img.img_name} className={`person-gallery-image`} img_array={images} isEdit={true} editingImgs={isEditing}/>
                    <div className="person-gallery-image-subtext">
                      {/* {img.subtext || img.img_name} */}
                      <div>Uploaded:</div> 
                      <div>{`${monthNames[img.saved_date.split("-")[1]-1]} `}{`${Number(img.saved_date.split("-")[2].split("T")[0])}, `}{img.saved_date.split("-")[0]}</div>
                    </div>
                    {selectedImgs.includes(img.media_id) && <div className="selected-mask"></div>}
                    {/* <button className='close-zoom-popup' onClick={onClose}>{'\u00D7'}</button> */}
                  </div>
                ))}
              </div>
            }
            {isDeleting && <Loading />}
          </div>
        </div>
      }
      <div className="edit-upload-buttons">
        <button 
          className={`${isEditing?"editing-button":"edit-button"}`}
          onClick={editImgMode}
          disabled={isDeleting}
        >
          {`${isEditing?"Cancel":"Edit List"}`}
        </button>
        {isEditing &&
          <button 
            className={"delete-imgs-button"}
            onClick={deleteImgs}
            disabled={selectedImgs.length === 0 || isDeleting}
          >
            Delete Images
          </button>
        }
      </div>
      <div className="upload-page-buttons"> 
        <div>
          <Link to={`/edit-img`} className="upload-link">Upload More Images</Link>
        </div>
        <div>
          <Link to={`/profile`} className="upload-link">Back to Profile</Link>
        </div>
      </div>
    </div>
  )
}